var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Griechisch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-40.6%",
    y: "-40.6%",
    width: "181.2%",
    height: "181.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.41824 12.4184,16 8,16 C3.58168,16 0,12.41824 0,8 C0,3.58168 3.58168,0 8,0 C12.4184,0 16,3.58168 16,8 L16,8 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.41824 12.4184,16 8,16 C3.5816,16 0,12.41824 0,8 C0,3.58168 3.5816,0 8,0 C12.4184,0 16,3.58168 16,8 L16,8 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags-/Griechenland",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1023",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-1020",
    fill: "#D8D8D8",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-1018",
    mask: "url(#mask-3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-1011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1010",
    fill: "#1A62A0",
    mask: "url(#mask-5)",
    points: "0 16 16 16 16 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1012",
    fill: "#FFFFFE",
    mask: "url(#mask-5)",
    points: "0 3.55552 16 3.55552 16 1.77776 0 1.77776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1013",
    fill: "#FFFFFE",
    mask: "url(#mask-5)",
    points: "0 7.11112 16 7.11112 16 5.33336 0 5.33336"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1014",
    fill: "#FFFFFE",
    mask: "url(#mask-5)",
    points: "0 10.66664 16 10.66664 16 8.88888 0 8.88888"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1015",
    fill: "#FFFFFE",
    mask: "url(#mask-5)",
    points: "0 14.22224 16 14.22224 16 12.44448 0 12.44448"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1016",
    fill: "#1A62A0",
    mask: "url(#mask-5)",
    points: "0 8.88888 8 8.88888 8 0 0 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1017",
    fill: "#FFFFFE",
    mask: "url(#mask-5)",
    points: "8 3.55552 5.3 3.55552 5.3 0 3.7 0 3.7 3.55552 0 3.55552 0 5.33336 3.7 5.33336 3.7 8.93336 5.3 8.93336 5.3 5.33336 8 5.33336 8 3.55552"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEl);
export default __webpack_public_path__ + "static/media/el.2037fdbb02cbc722599fd295f9c8b646.svg";
export { ForwardRef as ReactComponent };